import styled from 'styled-components';

const NOTE_COLORS: Record<string, string> = {
  green: '#1eab35',
  blue: '#2f6fed',
};

export const BoxCard = styled.div`
  width: 100%;
  padding: 24px;
  border-radius: 12px;
  background: #fff;
  box-shadow: 0 10px 26px rgb(0 0 0 / 5%);
  margin-bottom: 24px;
`;

export const PixOverlay = styled.div`
  position: fixed;
  inset: 0;
  z-index: 999;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background: rgb(0 0 0 / 30%);
`;

export const PixCard = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  width: 100%;
  max-width: 480px;
  padding: 28px;
  border-radius: 12px;
  background: #fff;
  box-shadow: 0 10px 26px rgb(0 0 0 / 12%);
`;

export const PixQrCode = styled.img`
  width: 220px;
  height: 220px;
  object-fit: contain;
`;

export const PixCopyField = styled.div`
  position: relative;
  width: 100%;
`;

export const PixCopyInput = styled.input`
  width: 100%;
  height: 40px;
  padding: 0 44px 0 12px;
  border: 1px solid #ced4da;
  border-radius: 4px;
  background: #f7f7f7;
  color: #2e3958;
  font-size: 13px;
  text-overflow: ellipsis;
`;

export const PixCopyButton = styled.button<{ $copied?: boolean }>`
  position: absolute;
  top: 50%;
  right: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  padding: 0;
  border: 0;
  border-radius: 4px;
  background: transparent;
  color: ${({ $copied }) => ($copied ? '#1eab35' : '#e71037')};
  font-size: 18px;
  cursor: pointer;
  transform: translateY(-50%);

  &:hover {
    background: #fdecef;
  }

  &:disabled {
    color: #c5c5c5;
    cursor: not-allowed;
  }
`;

export const PixActions = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
  width: 100%;
`;

export const Summary = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  gap: 24px;
`;

export const Avatar = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: #fdecef;
  overflow: hidden;

  svg {
    width: 22px;
    height: 22px;
    color: #e71037;
  }

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

export const Fields = styled.div`
  display: flex;
  flex: 1;
  justify-content: space-between;
  gap: 16px;
`;

export const Field = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
`;

export const Label = styled.span`
  font-size: 12px;
  font-weight: 600;
  line-height: 1.2;
  color: #757575;
`;

export const Value = styled.span`
  font-size: 16px;
  font-weight: 600;
  line-height: 1.2;
  color: #4a4b4a;
`;

export const Boxes = styled.div`
  display: grid;
  grid-template-columns: 1.7fr 1fr;
  gap: 24px;
  width: 100%;
  align-items: start;
`;

export const SideColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 100%;
  min-width: 0;
`;

export const Panel = styled.div<{ $compact?: boolean }>`
  display: flex;
  flex-direction: column;
  justify-content: ${({ $compact }) =>
    $compact ? 'flex-start' : 'space-between'};
  width: 100%;
  height: auto;
  min-height: ${({ $compact }) => ($compact ? '0' : '160px')};
  padding: ${({ $compact }) => ($compact ? '16px' : '24px')};
  border-radius: 12px;
  background: #fff;
  box-shadow: 0 10px 26px rgb(0 0 0 / 5%);
`;

export const PanelTitle = styled.h2`
  margin: 0;
  font-size: 1.2rem;
  font-weight: 700;
  color: #2e3958;
`;

export const PanelHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const CheckBadge = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background: #1eab35;

  svg {
    width: 14px;
    height: 14px;
    color: #fff;
    stroke-width: 3;
  }
`;

export const FinanceSections = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  width: 100%;
  margin-top: 20px;
  gap: 16px;
`;

export const FinancingSections = styled(FinanceSections)`
  margin-top: 12px;
`;

export const DebtColumn = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 24px;
  width: 100%;
  height: 100%;
`;

export const DebtPanel = styled(Panel)`
  height: auto;
  gap: 20px;
`;

export const FinancingList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 36px;
`;

export const DebtGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const DebtType = styled.span`
  color: #2e3958;
  font-size: 18px;
  font-weight: 700;
  line-height: 1.2;
`;

export const DebtCard = styled.div`
  padding: 16px;
  border: 1px solid #e6ebf2;
  border-radius: 8px;
`;

export const DebtNoticeRow = styled.div`
  display: flex;
  align-items: stretch;
  justify-content: space-between;
  gap: 16px;
`;

export const DebtFields = styled.div`
  display: flex;
  flex: 1;
  align-items: flex-start;
  min-width: 0;
`;

export const DebtRow = styled.div`
  padding-bottom: 12px;
  border-bottom: 1px solid #e6ebf2;

  &:last-child {
    padding-bottom: 0;
    border-bottom: none;
  }
`;

export const Feedback = styled.p`
  margin: 0 0 16px;
  color: #e71037;
  font-size: 14px;
`;

export const PanelFooter = styled.div`
  display: flex;
  align-items: stretch;
  justify-content: space-between;
  gap: 16px;
  margin-top: 12px;
`;

export const InfoNotice = styled.div<{ $tone?: 'green' }>`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 14px;
  border-radius: 8px;
  border: 1px solid ${({ $tone }) => ($tone === 'green' ? '#1eab35' : '#2f6fed')};
  background: ${({ $tone }) => ($tone === 'green' ? '#e8f7ec' : '#ecf1ff')};
  color: ${({ $tone }) => ($tone === 'green' ? '#1eab35' : '#2f6fed')};
  font-size: 13px;
  font-weight: 400;
  line-height: 1.3;
`;

export const FooterButton = styled.div`
  display: flex;

  button {
    height: 100% !important;
    padding-top: 0;
    padding-bottom: 0;
  }
`;

export const InfoBadge = styled.span<{ $tone?: 'green' }>`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: ${({ $tone }) => ($tone === 'green' ? '#1eab35' : '#2f6fed')};
  color: #fff;
  font-size: 12px;
  font-weight: 700;
  line-height: 1;
`;

export const NegotiationPanel = styled(Panel)`
  justify-content: flex-start;
  gap: 20px;
  min-height: 0;
`;

export const NegotiationFloor = styled.div`
  display: grid;
  grid-template-columns: 30% minmax(0, 1fr);
  gap: 24px;
  align-items: start;
`;

export const NegotiationColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  min-width: 0;
`;

export const ConfigStack = styled.div`
  display: flex;
  flex-direction: column;
  gap: 28px;
  width: 100%;
`;

export const ConfigBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-top: 28px;
`;

export const Subtitle = styled.span`
  font-size: 14px;
  font-weight: 700;
  line-height: 1.2;
  color: #2e3958;
`;

export const RangeRow = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 12px;
`;

export const RangeBlock = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  min-width: 0;
`;

export const RangeLimits = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 2px;
`;

export const RangeLimit = styled.span`
  font-size: 12px;
  font-weight: 400;
  line-height: 1.2;
  color: #b0b0b0;
`;

export const Range = styled.input`
  flex: 1;
  width: 100%;
  min-width: 0;
  accent-color: #e71037;
  cursor: pointer;

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const PercentField = styled.input`
  width: 48px;
  height: 40px;
  padding: 0 8px;
  border: 1px solid #ced4da;
  border-radius: 4px;
  background: #fff;
  color: #2e3958;
  font-size: 14px;
  font-weight: 600;
  text-align: center;

  &:disabled {
    background: #f7f7f7;
    color: #757575;
    cursor: not-allowed;
  }
`;

export const PercentSuffix = styled.span`
  font-size: 14px;
  font-weight: 600;
  color: #2e3958;
`;

export const PercentGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
`;

export const SummaryTabs = styled.div`
  display: flex;
  gap: 24px;
  border-bottom: 1px solid #e6e6e6;
`;

export const SummaryTab = styled.button<{ $active?: boolean }>`
  margin: 0;
  padding: 0 0 10px;
  border: 0;
  border-bottom: 2px solid
    ${({ $active }) => ($active ? '#e71037' : 'transparent')};
  background: transparent;
  color: ${({ $active }) => ($active ? '#e71037' : '#757575')};
  font-size: 14px;
  font-weight: 700;
  line-height: 1.2;
  cursor: pointer;

  &:disabled {
    cursor: not-allowed;
  }
`;

export const SummaryRow = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  width: 100%;
`;

export const SummarySection = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 6px;
  min-width: 0;
  padding: 0 16px;

  &:first-child {
    padding-left: 0;
  }

  &:last-child {
    padding-right: 0;
  }

  & + & {
    border-left: 1px solid #e6e6e6;
  }
`;

export const SummaryStack = styled.div`
  display: flex;
  flex-direction: column;
  gap: 14px;
`;

export const SummaryBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

export const AgreementPanel = styled(Panel)`
  justify-content: flex-start;
  gap: 16px;
  min-height: 0;
`;

export const SummaryLine = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  width: 100%;
`;

export const WarningNotice = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 10px 14px;
  border-radius: 8px;
  border: 1px solid #f0a202;
  background: #fff6e0;
  color: #e8770a;
  font-size: 13px;
  font-weight: 400;
  line-height: 1.3;
`;

export const WarningBadge = styled.span`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 18px;
  height: 16px;
  margin-top: 1px;
  color: #fff;
  font-size: 10px;
  font-weight: 700;
  line-height: 1;

  &::before {
    content: '';
    position: absolute;
    inset: 0;
    background: #f5c400;
    clip-path: polygon(50% 0, 100% 100%, 0 100%);
  }

  span {
    position: relative;
    z-index: 1;
    margin-top: 4px;
  }
`;

export const SummaryActions = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
`;

export const InstallmentField = styled.input`
  width: 128px;
  height: 40px;
  padding: 0 8px;
  border: 1px solid #ced4da;
  border-radius: 4px;
  background: #fff;
  color: #2e3958;
  font-size: 14px;
  font-weight: 600;
  text-align: center;

  &:disabled {
    background: #f7f7f7;
    color: #757575;
    cursor: not-allowed;
  }
`;

export const InlineNote = styled.span<{ $tone?: 'green' | 'blue' }>`
  display: inline-flex;
  align-items: flex-start;
  gap: 6px;
  font-size: 12px;
  font-weight: 400;
  line-height: 1.3;
  color: ${({ $tone }) => NOTE_COLORS[$tone] ?? '#b0b0b0'};
`;

export const NoteBadge = styled.span<{ $tone?: 'green' | 'blue' }>`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 16px;
  height: 16px;
  margin-top: 1px;
  border-radius: 50%;
  background: ${({ $tone }) => ($tone === 'green' ? '#1eab35' : '#2f6fed')};
  color: #fff;
  font-size: 11px;
  font-weight: 700;
  line-height: 1;

  svg {
    width: 10px;
    height: 10px;
    stroke-width: 3;
  }
`;

export const TypeList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  align-items: flex-start;
`;

export const RadioRow = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const RadioOption = styled.label<{ $disabled?: boolean }>`
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: ${({ $disabled }) => ($disabled ? 'not-allowed' : 'pointer')};
  font-size: 14px;
  font-weight: 400;
  color: #2e3958;
`;

export const DiscountChip = styled.span`
  display: inline-flex;
  align-items: center;
  flex-shrink: 0;
  padding: 6px 10px;
  border: 1px solid #b7e7c4;
  border-radius: 8px;
  background: #e8f7ec;
  color: #127a28;
  font-size: 12px;
  font-weight: 600;
  line-height: 1.2;
`;

export const EntryRow = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 16px;
  width: 100%;
`;

export const EntryColumn = styled.div<{ $end?: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: ${({ $end }) => ($end ? 'flex-end' : 'flex-start')};
  gap: 6px;
`;

export const EntryLabel = styled.span`
  font-size: 14px;
  font-weight: 400;
  line-height: 1.2;
  color: #2e3958;
`;

export const InstallmentRow = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 16px;
  align-items: start;
  width: 100%;
`;

export const FinanceSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 0;
  padding: 0 16px;

  &:first-child {
    padding-left: 0;
  }

  &:last-child {
    padding-right: 0;
  }

  & + & {
    border-left: 1px solid #e6e6e6;
  }
`;

export const SectionTitle = styled.span`
  font-size: 14px;
  font-weight: 700;
  line-height: 1.2;
  color: #2e3958;
`;

export const DateFieldWrap = styled.div`
  position: relative;
  width: 100%;
`;

export const DateFieldValue = styled.span<{ $empty?: boolean }>`
  color: ${({ $empty }) => ($empty ? '#afafaf' : '#4a4b4a')};
`;

export const DateFieldButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 40px;
  padding: 0 12px;
  border: 1px solid #ced4da;
  border-radius: 4px;
  background: #fff;
  color: #4a4b4a;
  font-size: 14px;
  cursor: pointer;

  svg {
    width: 18px;
    height: 18px;
    color: #e71037;
  }

  &:disabled {
    background: #f7f7f7;
    color: #757575;
    cursor: not-allowed;

    svg {
      color: #b0b0b0;
    }
  }
`;

export const Calendar = styled.div`
  position: absolute;
  z-index: 5;
  top: 44px;
  left: 0;
  width: 260px;
  padding: 12px;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0 10px 26px rgb(0 0 0 / 12%);
`;

export const CalendarHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
  color: #2e3958;
  font-size: 14px;
  text-transform: capitalize;

  button {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 28px;
    height: 28px;
    border: 0;
    border-radius: 4px;
    background: transparent;
    color: #e71037;
    cursor: pointer;
  }
`;

export const CalendarWeek = styled.div`
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  margin-bottom: 4px;
  color: #b0b0b0;
  font-size: 12px;
  text-align: center;
`;

export const CalendarGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 2px;
`;

export const CalendarDay = styled.button<{
  $selected?: boolean;
  $outside?: boolean;
  $disabled?: boolean;
}>`
  height: 32px;
  border: 0;
  border-radius: 4px;
  background: ${({ $selected }) => ($selected ? '#e71037' : 'transparent')};
  color: ${({ $selected, $outside, $disabled }) => {
    if ($selected) return '#fff';
    if ($disabled || $outside) return '#c5c5c5';
    return '#2e3958';
  }};
  font-size: 13px;
  cursor: ${({ $disabled }) => ($disabled ? 'not-allowed' : 'pointer')};

  &:hover {
    background: ${({ $selected, $disabled }) => {
      if ($disabled) return 'transparent';
      if ($selected) return '#e71037';
      return '#fdecef';
    }};
  }
`;

export const NewInvoice = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const RequiredError = styled.span`
  margin-top: 4px;
  font-size: 13px;
  font-weight: 400;
  line-height: 1.3;
  color: #e71037;
`;

export const DueDateHint = styled.span`
  margin-top: 4px;
  font-size: 13px;
  font-weight: 400;
  line-height: 1.3;
  color: #b0b0b0;
`;

export const NewInvoiceValue = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-top: 8px;
`;

export const MutedText = styled.span`
  font-size: 13px;
  font-weight: 400;
  line-height: 1.2;
  color: #b0b0b0;
`;

export const PlainText = styled.span`
  font-size: 14px;
  font-weight: 400;
  line-height: 1.2;
  color: #2e3958;
`;

export const Amount = styled.span`
  font-size: 16px;
  font-weight: 700;
  line-height: 1.2;
  color: #2e3958;
`;

export const Status = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin-top: 4px;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.2;
  color: #e71037;
`;

export const StatusDot = styled.span`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #e71037;
`;

export const SectionNote = styled.span`
  display: inline-flex;
  align-items: center;
  margin-top: 4px;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.2;
  color: #2e3958;
`;

export const Receipt = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: space-between;
  gap: 14px;
  margin-top: 20px;
`;

export const ReceiptRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
`;

export const ReceiptLabel = styled.span`
  font-size: 13px;
  font-weight: 400;
  line-height: 1.2;
  text-align: left;
  color: #b0b0b0;
`;

export const ReceiptStrong = styled.span`
  font-size: 14px;
  font-weight: 700;
  line-height: 1.2;
  text-align: left;
  color: #2e3958;
`;

export const DiscountAmount = styled.span`
  font-size: 16px;
  font-weight: 700;
  line-height: 1.2;
  color: #1eab35;
`;

export const ReceiptDivider = styled.div`
  height: 1px;
  background: #e6e6e6;
`;
